"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAUTH_EMAIL_PROVIDERS = exports.EmailProviderSyncHelpLinks = exports.EmailProviderNames = exports.EmailProviderLogos = exports.EmailProviderApiKeyHelpLinks = exports.APIKEY_EMAIL_PROVIDERS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("settings-ui-sdk/EspSync/constants");

var _aweber = _interopRequireDefault(require("bender-url!settings-ui-modules/marketing/modules/esp-sync/images/aweber.jpg"));

var _campaignMonitor = _interopRequireDefault(require("bender-url!settings-ui-modules/marketing/modules/esp-sync/images/campaign-monitor.png"));

var _constantContact = _interopRequireDefault(require("bender-url!settings-ui-modules/marketing/modules/esp-sync/images/constant-contact.png"));

var _getresponse = _interopRequireDefault(require("bender-url!settings-ui-modules/marketing/modules/esp-sync/images/getresponse.png"));

var _mailchimp = _interopRequireDefault(require("bender-url!settings-ui-modules/marketing/modules/esp-sync/images/mailchimp.png"));

var _EmailProviderApiKeyH, _EmailProviderNames, _EmailProviderSyncHel;

var APIKEY_EMAIL_PROVIDERS = [_constants.EspType.CAMPAIGN_MONITOR, _constants.EspType.GET_RESPONSE];
exports.APIKEY_EMAIL_PROVIDERS = APIKEY_EMAIL_PROVIDERS;
var EmailProviderApiKeyHelpLinks = (_EmailProviderApiKeyH = {}, (0, _defineProperty2.default)(_EmailProviderApiKeyH, _constants.EspType.CAMPAIGN_MONITOR, 'https://help.campaignmonitor.com/topic.aspx?t=206'), (0, _defineProperty2.default)(_EmailProviderApiKeyH, _constants.EspType.GET_RESPONSE, 'https://support.getresponse.com/faq/where-i-find-api-key'), _EmailProviderApiKeyH);
exports.EmailProviderApiKeyHelpLinks = EmailProviderApiKeyHelpLinks;
var EmailProviderLogos = [{
  id: _constants.EspType.MAILCHIMP_OAUTH,
  size: '3rem',
  src: _mailchimp.default
}, {
  id: _constants.EspType.CAMPAIGN_MONITOR,
  size: '2rem',
  src: _campaignMonitor.default
}, {
  id: _constants.EspType.AWEBER,
  name: 'Aweber',
  size: '2.5rem',
  src: _aweber.default
}, {
  id: _constants.EspType.CONSTANT_CONTACT,
  size: '4rem',
  src: _constantContact.default
}, {
  id: _constants.EspType.GET_RESPONSE,
  size: '2rem',
  src: _getresponse.default
}];
exports.EmailProviderLogos = EmailProviderLogos;
var EmailProviderNames = (_EmailProviderNames = {}, (0, _defineProperty2.default)(_EmailProviderNames, _constants.EspType.AWEBER, 'AWeber'), (0, _defineProperty2.default)(_EmailProviderNames, _constants.EspType.CONSTANT_CONTACT, 'Constant Contact'), (0, _defineProperty2.default)(_EmailProviderNames, _constants.EspType.CAMPAIGN_MONITOR, 'Campaign Monitor'), (0, _defineProperty2.default)(_EmailProviderNames, _constants.EspType.GET_RESPONSE, 'GetResponse'), (0, _defineProperty2.default)(_EmailProviderNames, _constants.EspType.MAILCHIMP_OAUTH, 'Mailchimp'), _EmailProviderNames);
exports.EmailProviderNames = EmailProviderNames;
var EmailProviderSyncHelpLinks = (_EmailProviderSyncHel = {}, (0, _defineProperty2.default)(_EmailProviderSyncHel, _constants.EspType.AWEBER, 'http://support.leadin.com/hc/en-us/articles/205953045#push'), (0, _defineProperty2.default)(_EmailProviderSyncHel, _constants.EspType.CONSTANT_CONTACT, 'http://support.leadin.com/hc/en-us/articles/205259439#push'), (0, _defineProperty2.default)(_EmailProviderSyncHel, _constants.EspType.CAMPAIGN_MONITOR, 'http://support.leadin.com/hc/en-us/articles/205952925#push'), (0, _defineProperty2.default)(_EmailProviderSyncHel, _constants.EspType.GET_RESPONSE, 'http://support.leadin.com/hc/en-us/articles/205259459#push'), (0, _defineProperty2.default)(_EmailProviderSyncHel, _constants.EspType.MAILCHIMP_OAUTH, 'https://knowledge.hubspot.com/pop-up-forms/connect-pop-up-forms-and-non-hubspot-forms-to-mailchimp'), _EmailProviderSyncHel);
exports.EmailProviderSyncHelpLinks = EmailProviderSyncHelpLinks;
var OAUTH_EMAIL_PROVIDERS = [_constants.EspType.AWEBER, _constants.EspType.CONSTANT_CONTACT, _constants.EspType.MAILCHIMP_OAUTH];
exports.OAUTH_EMAIL_PROVIDERS = OAUTH_EMAIL_PROVIDERS;